import { loginCookie } from '../login/common';
var qqAppid = '101795054';
var wxAppid = 'wxca942bbff22e0e51';
var miloSelfConfig = {
  isMiloWayCookies: false,
  appName: 'tv'
};

var loadJsApi = function loadJsApi() {
  return new Promise(function (resolve) {
    if (window.TenvideoJSBridge) {
      // alert('milo-TenvideoJSBridge-loaded')
      resolve(window.TenvideoJSBridge);
      return;
    }

    document.addEventListener('onTenvideoJSBridgeReady', function () {
      resolve(window.TenvideoJSBridge);
    }, false);
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('actionLogin', {
      type: 'tv'
    }, function () {
      location.reload();
    });
  })["catch"](function () {});
};

var loginByWX = function loginByWX() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('actionLogin', {
      type: 'wx'
    }, function () {
      location.reload();
    });
  })["catch"](function () {});
};

var loginByQQ = function loginByQQ() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('actionLogin', {
      type: 'qq'
    }, function () {
      location.reload();
    });
  })["catch"](function () {});
};

var setAppCookie = function setAppCookie() {
  console.log('beforeSetCookie');
  return new Promise(function (resolve, reject) {
    loadJsApi().then(function (JsBridge) {
      JsBridge.invoke('getMainCookie', null, function (result) {
        var res = JSON.parse(result);

        var getCookieFromString = function getCookieFromString(sString, sName) {
          var name = "".concat(sName, "=");
          var ca = sString.split(';');

          for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();

            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }

          return null;
        }; // alert(res && res.errCode && res.errCode === 0 && res.result)


        if (res && (res.errCode === 0 || res.errCode === '0') && res.result) {
          console.log('getUserLoginToken返回', res.result);
          var logintype = res.result.type;
          var mobileqopenid = getCookieFromString(res.result.cookie, 'vqq_openid');
          var mobileqtoken = getCookieFromString(res.result.cookie, 'vqq_access_token');
          var wopenid = getCookieFromString(res.result.cookie, 'openid');
          var waccesstoken = getCookieFromString(res.result.cookie, 'access_token');
          console.log(logintype, mobileqopenid, mobileqtoken, wopenid, waccesstoken);
          loginCookie.clearQQ();

          if (logintype === 'qq' && mobileqopenid && mobileqtoken) {
            window.iUseQQConnect = 1;
            loginCookie.setLocal({
              acctype: 'qc',
              appid: qqAppid,
              openid: mobileqopenid,
              access_token: mobileqtoken
            }, 7200);
          } else if (logintype === 'wx' && wopenid && waccesstoken) {
            loginCookie.setQQ({
              acctype: 'wx',
              appid: wxAppid,
              openid: wopenid,
              access_token: waccesstoken
            }, 7200);
          }

          resolve();
        } else {
          reject();
        }
      });
    })["catch"](function () {
      reject();
    });
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    loadJsApi().then(function (JsBridge) {
      JsBridge.invoke('getMainLoginType', null, function (result) {
        var res = JSON.parse(result);

        if (res && (res.errCode === 0 || res.errCode === '0')) {
          // alert('res',res.result)
          if (res.result === 'wx') {
            // alert('wx')
            resolve('wx');
          }

          if (res.result === 'qq') {
            // alert('qc')
            resolve('qc');
          }
        } else {
          resolve(null);
        }
      });
    })["catch"](function () {});
  });
};

var logout = function logout() {
  loadJsApi().then(function (JsBridge) {
    JsBridge.invoke('logout', null);
  })["catch"](function () {});
};

var tv = {
  loadJsApi: loadJsApi,
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  miloSelfConfig: miloSelfConfig
};
export default tv;